import { useDispatch, useSelector } from "react-redux";
import {
  bulkJobOut,
  getAllJobCard,
  getAllJobCards,
  getAllParallelJobCard,
  getJobCardById,
} from "../../actions/JobCardActions";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Footer from "../../layouts/footer";
import DocumentModal from "./modals/DocumentModal";
import { ThreeDots } from "react-loader-spinner";
import moment from "moment/moment";
import JobOutModal from "./modals/JobOut";
import ItemsModal from "./modals/items";
import { styleSelect } from "../../constants/customStyles";
import Select from "react-select";
import { getAllProductCategory } from "../../actions/ProductCategoryActions";
import { getAllProduct } from "../../actions/ProductActions";
import { getAllPoliceStation } from "../../actions/PoliceStationActions";
import Mobilemenu from "../../layouts/mobile-menu";
import { getAllCustomer } from "../../actions/CustomerActions";
import { getAllInsuranceType } from "../../actions/InsuranceTypeActions";
import { getAllInsuranceCompany } from "../../actions/InsuranceCompanyActions";
import React from "react";
import { Button } from "react-bootstrap";
import axios from "axios";
import Toast from "../../components/Toast";

function JobCard() {
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [currentRowsPerPage, setCurrentRowsPerPage] = useState(10); // Default 30 rows per page
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);

  const jobCards = useSelector((state) => state?.jobCard?.jobCards?.data);
  // const allJobCards = useSelector(state => state?.jobCard?.jobCards?.data);
  const jobCardsPagination = useSelector((state) => state?.jobCard?.jobCards);
  const parallelJobCards = useSelector(
    (state) => state?.jobCard?.parallelJobCards?.data
  );
  const parallelJobCardsPagination = useSelector(
    (state) => state?.jobCard?.parallelJobCards
  );
  const customers = useSelector((state) => state?.customer?.customers?.data);
  const insuranceCompanies = useSelector(
    (state) => state?.insuranceCompany?.insuranceCompanies?.data
  );
  const loading = useSelector((state) => state?.loading?.indexLoading);
  const user_permissions = JSON.parse(localStorage.getItem("perm"));

  useEffect(() => {
    dispatch(getAllJobCard(page, currentRowsPerPage, multifilters ?? ""));
    // dispatch(getAllJobCards(null, 9999999999, filter ?? ""));
    dispatch(
      getAllParallelJobCard(
        page,
        currentRowsPerPage,
        multifiltersParellel ?? ""
      )
    );
    dispatch(getAllCustomer(null, 9999, { status: 1 }));
    dispatch(getAllCustomer(null, 9999, { status: 1 }));
    dispatch(getAllInsuranceCompany(null, 9999, { status: 1 }));
    dispatch(getAllInsuranceType(null, 9999999, { status: 1 }));
  }, [dispatch]);

  // const onChangeRowsPerPage = (currentRowsPerPage) => {
  //     filterSearch(page, currentRowsPerPage);
  //     // dispatch(getAllJobCard(page, currentRowsPerPage, multifilters ?? ""));
  // }
  const onChangePage = (page, currentRowsPerPage) => {
    setPage(page);
    setCurrentRowsPerPage(currentRowsPerPage);
    const filterParams = multifilters.reduce((acc, filter) => {
      acc[filter.key] = filter.value;
      return acc;
    }, {});

    dispatch(getAllJobCard(page, currentRowsPerPage, filterParams ?? ""));
    // dispatch(getAllJobCard(page, currentRowsPerPage, multifilters ?? ""));
  };
  const onChangeParallelPage = (page) => {
    // return () => {
    dispatch(
      getAllParallelJobCard(
        page,
        currentRowsPerPage,
        multifiltersParellel ?? ""
      )
    );
    // }
  };

  useEffect(() => {
    // Update the paginationTotalRows prop to reflect the actual number of rows that are available
    setPaginationTotalRows(jobCardsPagination.total);
  }, [jobCardsPagination]);

  // useEffect(() => {
  //     getData(page, currentRowsPerPage);
  // }, [page])

  // const getData = (pageNo, currentRowsPerPage = 10) => {
  //     dispatch(getAllJobCard(page, currentRowsPerPage, ''));
  //     dispatch(getAllParallelJobCard(page, currentRowsPerPage, ''));
  // }

  const [modalJobCard, setModalJobCard] = useState({});
  const [modalJobCardId, setModalJobCardId] = useState("");

  const onClickItemsModal = (e, row) => {
    setModalJobCard(row);
    dispatch(getJobCardById(row.job_card_id));
    dispatch(getAllProductCategory(null, 999999, ""));
    dispatch(getAllProduct(null, 999999, ""));
  };

  const onClickDocumentModal = (e, job_id) => {
    dispatch(getAllPoliceStation(null, ""));
    setModalJobCardId(job_id);
    dispatch(getJobCardById(job_id));
  };
  const onClickJobOutModal = (e, row) => {
    setModalJobCard(row);
    setModalJobCardId(row.job_card_id);
    dispatch(getJobCardById(row.job_card_id));
  };

  const jobCard = useSelector((state) => state?.jobCard?.jobCard);

  const customStyles = {
    table: {
      style: {
        backgroundColor: "rgb(241, 245, 248)",
      },
    },
    headRow: {
      style: {
        border: "none !important",
      },
    },
    head: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
        border: "none !important",
      },
    },
    rows: {
      style: {
        minHeight: "40px",
        paddingLeft: "10px",
        backgroundColor: "#fff !important",
        borderTop: "none !important",
        marginBottom: "10px",
        borderRadius: "30px",
        paddingRight: "5px",
        "&:not(:last-of-type)": {
          border: "none",
        },
      },
    },
    body: {
      style: {
        backgroundColor: "rgb(241, 245, 248)",
      },
    },
    headCells: {
      style: {
        fontSize: "14px",
        fontWeight: "700",
        textTransform: "uppercase",
        border: "none !important",
        backgroundColor: "rgb(241, 245, 248)",
        // justifyContent: 'center'
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        // 'div:first-child': {
        //     overflow: 'visible !important'
        // }
        // justifyContent: 'center'
      },
    },
    pagination: {
      style: {
        backgroundColor: "rgb(241,245,248)",
        borderTop: "none !important",
      },
    },
  };

  const columns = [
    {
      cell: (row) =>
        user_permissions.some(
          (item) =>
            item.permission_id == "9" ||
            item.permission_id == "10" ||
            item.permission_id == "8"
        ) ? (
          <div className="dropdown">
            <button
              className="dropdown-toggle bg-white py-0 px-2 text-gray-700 dark-text-gray-300"
              aria-expanded="false"
              data-bs-toggle="dropdown"
            >
              <span className="d-flex align-items-center fs-base justify-content-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-settings me-1 w-6 h-6"
                >
                  <circle cx="12" cy="12" r="3"></circle>
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
                </svg>
                Actions
              </span>
            </button>
            <div className="dropdown-menu w-56">
              <div className="dropdown-content">
                {user_permissions.some((item) => item.permission_id == "10") &&
                  (row?.job_out != 1 ||
                    user_permissions.some(
                      (item) => item.permission_id == "42"
                    )) && (
                    <Link
                      className="d-flex align-items-center fs-base py-1"
                      to={`/jobCard/add/${row.estimate_id}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-edit me-1 w-6 h-6"
                      >
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                      </svg>
                      Edit
                    </Link>
                  )}

                {user_permissions.some(
                  (item) => item.permission_id == "10"
                ) && (
                  <Link
                    data-bs-target="#document-modal"
                    onClick={(e) => onClickDocumentModal(e, row.job_card_id)}
                    data-bs-toggle="modal"
                    className="d-flex align-items-center fs-base py-1 text-theme-10"
                  >
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="feather feather-file me-1 w-6 h-6"
                    >
                      <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                      <polyline points="13 2 13 9 20 9"></polyline>
                    </svg>{" "}
                    Document{" "}
                  </Link>
                )}
                {user_permissions.some(
                  (item) => item.permission_id == "10"
                ) && (
                  <Link
                    data-bs-target="#items-modal"
                    onClick={(e) => onClickItemsModal(e, row)}
                    data-bs-toggle="modal"
                    className="d-flex align-items-center fs-base py-1 text-theme-11"
                  >
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-package me-1 w-6 h-6"
                    >
                      <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line>
                      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                      <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                      <line x1="12" y1="22.08" x2="12" y2="12"></line>
                    </svg>{" "}
                    Items{" "}
                  </Link>
                )}
                {user_permissions.some(
                  (item) => item.permission_id == "10"
                ) && (
                  <Link
                    data-bs-target="#jobOut-modal"
                    onClick={(e) => onClickJobOutModal(e, row)}
                    data-bs-toggle="modal"
                    className="d-flex align-items-center fs-base py-1 text-theme-9"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-check-square me-1 w-6 h-6"
                    >
                      <polyline points="9 11 12 14 22 4"></polyline>
                      <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                    </svg>{" "}
                    Job Out{" "}
                  </Link>
                )}
                {row?.lpo_claim_id && (
                  <span>
                    <Link
                      to={`/jobCard/taxInvoice/${row.job_card_id}`}
                      target="_blank"
                      className="d-flex align-items-center fs-base py-1 text-primary"
                    >
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="feather feather-file me-1 w-6 h-6"
                      >
                        <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                        <polyline points="13 2 13 9 20 9"></polyline>
                      </svg>{" "}
                      Tax Invoice{" "}
                    </Link>
                    <Link
                      to={`/jobCard/excessTaxInvoice/${row.job_card_id}`}
                      target="_blank"
                      className="d-flex align-items-center fs-base py-1 text-primary"
                    >
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="feather feather-file me-1 w-6 h-6"
                      >
                        <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                        <polyline points="13 2 13 9 20 9"></polyline>
                      </svg>{" "}
                      Tax Excess Invoice{" "}
                    </Link>
                  </span>
                )}
                <Link
                  to={`/jobCard/invoice/${row.job_card_id}`}
                  target="_blank"
                  className="d-flex align-items-center fs-base py-1 text-theme-12"
                >
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="feather feather-file me-1 w-6 h-6"
                  >
                    <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                    <polyline points="13 2 13 9 20 9"></polyline>
                  </svg>{" "}
                  Service JobCard{" "}
                </Link>
              </div>
            </div>
          </div>
        ) : null,
    },
    {
      name: "STATUS",
      selector: (row) =>
        row?.job_out != 1 ? (
          <span className="text-theme-11 fw-medium">Job In</span>
        ) : (
          <span className="text-theme-9 fw-medium">Job Out</span>
        ),
      sortable: true,
      width: "100px",
    },
    {
      name: "INVOICE STATUS",
      selector: (row) =>
        row?.invoice_status === "paid" ? (
          <span className="text-theme-9 fw-medium">Paid</span>
        ) : row?.invoice_status != "-" ? (
          <span className="text-theme-7 fw-medium text-capitalize">
            {row.invoice_status}
          </span>
        ) : row?.pay_type ? (
          <span className="text-theme-1 text-nowrap fw-medium text-capitalize">
            {row.pay_type}
          </span>
        ) : (
          <span className="text-theme-6 fw-medium">Unpaid</span>
        ),
      sortable: true,
      width: "100px",
    },
    {
      name: "INVOICE NO.",
      selector: (row) => row?.invoice_name,
      sortable: true,
      // width: '100px'
    },
    {
      name: "JOB NO.",
      selector: (row) => row.job_card_id,
      sortable: true,
      width: "100px",
    },
    {
      name: "CUSTOMER NAME",
      selector: (row) => row?.customer_name,
      sortable: true,
      // width: '23%'
    },
    {
      name: "REFERENCE",
      selector: (row) => row?.reference,
      sortable: true,
      // width: '23%'
    },
    {
      name: "VEHICLE NAME",
      selector: (row) => row?.estimate?.vehicle?.vehicle_make?.name,
      sortable: true,
      // width: '23%'
    },
    {
      name: "PLATE NUMBER",
      selector: (row) =>
        row?.estimate?.vehicle?.plate_number +
        " " +
        row?.estimate?.vehicle?.state?.name,
      sortable: true,
      // width: '23%'
    },
    {
      name: "CHASIS NUMBER",
      selector: (row) => row?.estimate?.vehicle?.chasis_no,
      sortable: true,
      // width: '23%'
    },
    {
      name: "CONTRACTOR NAME",
      selector: (row) => row?.insurance_company?.name ?? "-",
      sortable: true,
      // width: '35%'
    },
    {
      name: "CLAIM NUMBER",
      selector: (row) => row?.lpo_claim?.lpo_no,
      sortable: true,
      // width: '23%'
    },
    {
      name: "LPO DATE",
      selector: (row) => row?.lpo_claim?.date ?? "-",
      sortable: true,
      // width: '23%'
    },
    {
      name: "LPO VALUE",
      selector: (row) => row?.lpo_claim?.lpo_value ?? "-",
      sortable: true,
      // width: '23%'
    },
    {
      name: "LPO EXCESS",
      selector: (row) => row?.lpo_claim?.excess ?? "-",
      sortable: true,
      // width: '23%'
    },
    {
      name: "LPO CLAIM TYPE",
      selector: (row) => row?.lpo_claim?.lpo_type ?? "-",
      sortable: true,
      // width: '23%'
    },
    {
      name: "POLICE REPORT NO",
      selector: (row) => row?.police_report?.report_no ?? "-",
      sortable: true,
      // width: '23%'
    },
    {
      name: "ESTIMATE NO",
      selector: (row) => row?.estimate_id ?? "-",
      sortable: true,
      // width: '23%'
    },
    {
      name: "JOBIN DATE",
      selector: (row) => row?.date,
      sortable: true,
      // width: '23%'
    },
    {
      name: "MOBILE IN",
      selector: (row) => row?.customer_mobile,
      sortable: true,
      // width: '23%'
    },
    {
      name: "OUT MOBILE",
      selector: (row) => row?.out_mobile ?? "-",
      sortable: true,
      // width: '23%'
    },
    {
      name: "START DATE",
      selector: (row) => row.start_on,
      sortable: true,
      // width: '8%'
    },
    {
      name: "LPO IS",
      selector: (row) => (row.lpo_claim?.lpo_no ? "True" : "False"),
      sortable: true,
      // width: '8%'
    },
    {
      name: "PAYMENT INFO",
      selector: (row) => row?.payment_info ?? "-",
      // sortable: true,
      // width: '8%'
    },
    {
      name: "PAY DATE",
      selector: (row) => row?.pay_date ?? "-",
      // sortable: true,
      // width: '8%'
    },
    {
      name: "CREATED ON",
      selector: (row) => moment(row.created_at).format("YYYY-MM-DD"),
      sortable: true,
      // width: '8%'
    },
  ];
  const parallelColumns = [
    {
      name: "JOB NO.",
      selector: (row) => row.job_card_id,
      sortable: true,
    },
    {
      name: "CUSTOMER NAME",
      selector: (row) => row?.customer?.name,
      sortable: true,
    },
    // {
    //     name: 'CONTRACTOR NAME',
    //     selector: row => row?.insurance_company?.name,
    //     sortable: true,
    // },
    // {
    //     name: 'DATE',
    //     selector: row => row.date,
    //     sortable: true,
    // },
    {
      name: "CREATED ON",
      selector: (row) => moment(row.created_at).format("YYYY-MM-DD"),
      sortable: true,
    },
  ];

  // const [filter, setFilter] = useState('');
  // const [filterOption, setFilterOption] = useState('');

  const [multifilters, setMultiFilters] = useState([]);
  const [multifilterOption, setMultiFilterOption] = useState([]);

  const [multifiltersParellel, setMultiFiltersParellel] = useState([]);
  const [multifilterOptionParellel, setMultiFilterOptionParellel] = useState(
    []
  );

  const filterOptions = [
    { value: "lpoIs", label: "LPO Is" },
    { value: "bulk_cases", label: "Bulk Cases" },
    { value: "job_id", label: "Job Id" },
    { value: "reference", label: "Reference" },
    { value: "estimate_id", label: "Estimate #" },
    { value: "plate_no", label: "Plate #" },
    { value: "chasis_no", label: "Chasis #" },
    { value: "vehicle_make", label: "Vehicle Name" },
    { value: "report_no", label: "Report #" },
    { value: "claim_no", label: "Claim #" },
    { value: "lpo_date", label: "LPO Date" },
    { value: "lpo_value", label: "LPO Value" },
    { value: "lpo_excess", label: "LPO Excess" },
    { value: "pymnt_info", label: "Payment Info" },
    { value: "customer_id", label: "Customer" },
    { value: "insurance_company_id", label: "Contractor" },
  ];

  const handleMultiFilter = (event) => {
    const { name, value } = event.target;
    setMultiFilters((prevFilters) => {
      const updatedFilters = [...prevFilters];
      const index = updatedFilters.findIndex((filter) => filter.key === name);
      if (index > -1) {
        updatedFilters[index].value = value;
      } else {
        updatedFilters.push({ key: name, value });
      }
      return updatedFilters;
    });
  };

  const handleMultiFilterDropdownCustomer = (selectedOption) => {
    setMultiFilters((prevFilters) => {
      const updatedFilters = [...prevFilters];
      const index = updatedFilters.findIndex(
        (filter) => filter.key === "customer_id"
      );
      if (index > -1) {
        updatedFilters[index] = {
          key: "customer_id",
          value: selectedOption.customer_id,
          label: selectedOption.name,
        };
      } else {
        updatedFilters.push({
          key: "customer_id",
          value: selectedOption.customer_id,
          label: selectedOption.name,
        });
      }
      return updatedFilters;
    });
  };
  const handleMultiFilterDropdownContractor = (selectedOption) => {
    setMultiFilters((prevFilters) => {
      const updatedFilters = [...prevFilters];
      const index = updatedFilters.findIndex(
        (filter) => filter.key === "insurance_company_id"
      );
      if (index > -1) {
        updatedFilters[index] = {
          key: "insurance_company_id",
          value: selectedOption.insurance_company_id,
          label: selectedOption.name,
        };
      } else {
        updatedFilters.push({
          key: "insurance_company_id",
          value: selectedOption.insurance_company_id,
          label: selectedOption.name,
        });
      }
      return updatedFilters;
    });
  };
  const handleMultiFilterDropdownLPO = (selectedOption) => {
    setMultiFilters((prevFilters) => {
      const updatedFilters = [...prevFilters];
      const index = updatedFilters.findIndex(
        (filter) => filter.key === "lpoIs"
      );
      if (index > -1) {
        updatedFilters[index] = {
          key: "lpoIs",
          value: selectedOption.value,
          label: selectedOption.label,
        };
      } else {
        updatedFilters.push({
          key: "lpoIs",
          value: selectedOption.value,
          label: selectedOption.label,
        });
      }
      return updatedFilters;
    });
  };
  const handleMultiFilterDropdownBulk = (selectedOption) => {
    setMultiFilters((prevFilters) => {
      const updatedFilters = [...prevFilters];
      const index = updatedFilters.findIndex(
        (filter) => filter.key === "bulk_cases"
      );
      if (index > -1) {
        updatedFilters[index] = {
          key: "bulk_cases",
          value: selectedOption.value,
          label: selectedOption.label,
        };
      } else {
        updatedFilters.push({
          key: "bulk_cases",
          value: selectedOption.value,
          label: selectedOption.label,
        });
      }
      return updatedFilters;
    });
  };

  // const handleFilter = (event) => {
  //     setFilter({
  //         ...filter,
  //         [event.target.name]: event.target.value,
  //     })
  // }
  // const handleFilters = (event) => {
  //     setFilterOption({
  //         value: event.value,
  //         label: event.label,
  //     })
  // }
  // const handleFilterDropdown = (event) => {
  //     setFilter({
  //         ...filter,
  //         'customer_id': event.customer_id,
  //         'customer_name': event.name,
  //     })
  // }
  // const handleFilterContractorDropdown = (event) => {
  //     setFilter({
  //         ...filter,
  //         'contractor_id': event.insurance_company_id,
  //         'contractor_name': event.name,
  //     })
  // }
  // const handleFilterLpo = (event) => {
  //     setFilter({
  //         ...filter,
  //         lpoIs: event.value,
  //         lpoIslabel: event.label,
  //     })
  // }
  const handleClearFilter = () => {
    // setFilter(null)
    // setFilterOption(null)
    setMultiFilters([]);
    setMultiFilterOption([]);
    dispatch(getAllJobCard(page, currentRowsPerPage, ""));
  };
  const handleExport = () => {
    let encodedFilter = "";

    if (multifilters !== "") {
      const filterParams = multifilters.reduce((acc, filter) => {
        acc[filter.key] = filter.value;
        return acc;
      }, {});
      const filterJson = JSON.stringify(filterParams);
      encodedFilter = encodeURIComponent(filterJson);
    }

    axios({
      method: "post",
      url: `http://garage-manager.clouxiplexi.com/api/export-job-cards?filter=${encodedFilter}`,
      responseType: "blob", // Important to specify blob format
    })
      .then((response) => {
        console.log(response);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "job_cards.xlsx"); // Specify the file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error exporting job cards:", error);
      });
  };

  // const handleKeyPress = (event) => {
  //     if (event.key === 'Enter') {
  //         event.preventDefault();
  //         filterSearch();
  //     }
  // }

  useEffect(() => {
    const updatedFilters = multifilterOption.map((option) => {
      const existingFilter = multifilters.find(
        (filter) => filter.key === option.value
      );
      return (
        existingFilter || { key: option.value, value: "", label: option.label }
      );
    });

    const preservedDateFilters = multifilters.filter(
      (filter) =>
        ["date_from", "date_to"].includes(filter.key) &&
        !multifilterOption.some((option) => option.value === filter.key)
    );

    const combinedFilters = [...updatedFilters, ...preservedDateFilters];

    setMultiFilters(combinedFilters);
    console.log("combinedFilters", combinedFilters);
  }, [multifilterOption]);

  const filterSearch = (page, currentRowsPerPage) => {
    const filterParams = multifilters.reduce((acc, filter) => {
      acc[filter.key] = filter.value;
      return acc;
    }, {});

    dispatch(getAllJobCard(1, currentRowsPerPage, filterParams ?? ""));
    // dispatch(getAllJobCard(page, currentRowsPerPage, filter ?? ''))
  };

  // const [parallelFilter, setParallelFilter] = useState('');

  const handleMultiFilterParellel = (event) => {
    const { name, value } = event.target;
    setMultiFiltersParellel((prevFilters) => {
      const updatedFilters = [...prevFilters];
      const index = updatedFilters.findIndex((filter) => filter.key === name);
      if (index > -1) {
        updatedFilters[index].value = value;
      } else {
        updatedFilters.push({ key: name, value });
      }
      return updatedFilters;
    });
  };

  const handleMultiFilterDropdownParellelCustomer = (selectedOption) => {
    setMultiFiltersParellel((prevFilters) => {
      const updatedFilters = [...prevFilters];
      const index = updatedFilters.findIndex(
        (filter) => filter.key === "customer_id"
      );
      if (index > -1) {
        updatedFilters[index] = {
          key: "customer_id",
          value: selectedOption.customer_id,
          label: selectedOption.name,
        };
      } else {
        updatedFilters.push({
          key: "customer_id",
          value: selectedOption.customer_id,
          label: selectedOption.name,
        });
      }
      return updatedFilters;
    });
  };
  const handleMultiFilterDropdownParellelContractor = (selectedOption) => {
    setMultiFilters((prevFilters) => {
      const updatedFilters = [...prevFilters];
      const index = updatedFilters.findIndex(
        (filter) => filter.key === "insurance_company_id"
      );
      if (index > -1) {
        updatedFilters[index] = {
          key: "insurance_company_id",
          value: selectedOption.insurance_company_id,
          label: selectedOption.name,
        };
      } else {
        updatedFilters.push({
          key: "insurance_company_id",
          value: selectedOption.insurance_company_id,
          label: selectedOption.name,
        });
      }
      return updatedFilters;
    });
  };
  const handleMultiFilterDropdownParellelLPO = (selectedOption) => {
    setMultiFilters((prevFilters) => {
      const updatedFilters = [...prevFilters];
      const index = updatedFilters.findIndex(
        (filter) => filter.key === "lpoIs"
      );
      if (index > -1) {
        updatedFilters[index] = {
          key: "lpoIs",
          value: selectedOption.value,
          label: selectedOption.label,
        };
      } else {
        updatedFilters.push({
          key: "lpoIs",
          value: selectedOption.value,
          label: selectedOption.label,
        });
      }
      return updatedFilters;
    });
  };

  // const handleParallelFilter = (event) => {
  //     setParallelFilter({
  //         ...parallelFilter,
  //         [event.target.name]: event.target.value,
  //     })
  // }
  const handleClearParallelFilter = () => {
    // setParallelFilter('')
    setMultiFiltersParellel([]);
    setMultiFilterOptionParellel([]);
    dispatch(getAllParallelJobCard(page, currentRowsPerPage, ""));
  };

  // const handleKeyPressParallel = (event) => {
  //     if (event.key === 'Enter') {
  //         event.preventDefault();
  //         parallelFilterSearch();
  //     }
  // }

  const parallelFilterSearch = () => {
    const filterParams = multifilters.reduce((acc, filter) => {
      acc[filter.key] = filter.value;
      return acc;
    }, {});
    dispatch(
      getAllParallelJobCard(page, currentRowsPerPage, filterParams ?? "")
    );
    // dispatch(getAllParallelJobCard(page, currentRowsPerPage, parallelFilter ?? ''))
  };

  useEffect(() => {
    const updatedFilters = multifilterOptionParellel.map((option) => {
      const existingFilter = multifiltersParellel.find(
        (filter) => filter.key === option.value
      );
      return (
        existingFilter || { key: option.value, value: "", label: option.label }
      );
    });

    const preservedDateFilters = multifiltersParellel.filter(
      (filter) =>
        ["date_from", "date_to"].includes(filter.key) &&
        !multifilterOptionParellel.some((option) => option.value === filter.key)
    );

    setMultiFiltersParellel([...updatedFilters, ...preservedDateFilters]);
  }, [multifilterOptionParellel]);

  const [selectedJobIds, setSelectedJobIds] = useState([]);
  const [referenceBulk, setReferenceBulk] = useState([]);
  const [payType, setPayType] = useState([]);
  const [payDate, setPayDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const handleSelectRows = (selectedRows) => {
    setSelectedJobIds(selectedRows.map((row) => row.job_card_id));
  };

  const savebulk = async () => {
    let data = {
      job_card_id: selectedJobIds,
      reference: referenceBulk,
      pay_type: payType,
      pay_date: payDate,
    };
    dispatch(bulkJobOut(data));
    const filterParams = multifilters.reduce((acc, filter) => {
      acc[filter.key] = filter.value;
      return acc;
    }, {});

    dispatch(getAllJobCard(1, currentRowsPerPage, filterParams ?? ""));
  };

  const handleCopyAllRows = () => {
    if (!jobCards || jobCards.length === 0) {
      Toast.fire({
        icon: "error",
        title: "No data to copy!",
      });
      return;
    }

    const copyableColumns = columns.slice(1); // Skip actions column

    const headers = copyableColumns.map((col) => col.name).join("\t");

    const rows = jobCards.map((row) =>
      copyableColumns
        .map((col) => {
          let value = "";
          try {
            value = col.selector ? col.selector(row) : "";
            if (typeof value === "object" && value !== null) {
              value = value.label || value.name || value.props.children || "";
            }
          } catch (e) {
            value = "";
          }
          return value;
        })
        .join("\t")
    );

    const tsvContent = [headers, ...rows].join("\n");

    navigator.clipboard
      .writeText(tsvContent)
      .then(() => {
        Toast.fire({
          icon: "success",
          title: "Data copied to clipboard!",
        });
      })
      .catch((err) => {
        Toast.fire({
          icon: "error",
          title: "Failed to copy data!",
        });
      });
  };

  return (
    <span>
      <Mobilemenu />
      <div className="content-body d-flex">
        <Webmenu />
        <div className="content">
          <Topbar />
          {/* {
                    loading ?
                        <ThreeDots
                            height="80"
                            width="80"
                            radius="9"
                            color="#2d3748"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                            wrapperClassName=""
                            visible={loading}
                        /> : */}
          <span>
            {/* <!-- BEGIN: Data List --> */}
            <div className="py-5">
              <ul className="pos__tabs nav nav-pills rounded-2" role="tablist">
                <li
                  id="investigations-tab"
                  className="nav-item box mx-3 flex-1"
                  role="presentation"
                >
                  <button
                    className="nav-link w-full pt-2 pb-2.5 active"
                    data-bs-toggle="pill"
                    data-bs-target="#investigations"
                    type="button"
                    role="tab"
                    aria-controls="investigations-tab"
                    aria-selected="true"
                  >
                    Job Cards
                  </button>
                </li>
                <li
                  id="parallelInvestigations-tab"
                  className="nav-item box mx-3 flex-1"
                  role="presentation"
                >
                  <button
                    className="nav-link w-full pt-2 pb-2.5"
                    data-bs-toggle="pill"
                    data-bs-target="#parallelInvestigations"
                    type="button"
                    role="tab"
                    aria-controls="parallelInvestigations-tab"
                    aria-selected="false"
                  >
                    Parallel Job Cards
                  </button>
                </li>
              </ul>
              <div className="tab-content">
                <div
                  className="tab-pane fade show active"
                  id="investigations"
                  role="tabpanel"
                  aria-labelledby="investigations-tab"
                >
                  <div className="intro-y g-col-12 px-3 mt-5 d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-between mt-2">
                    {user_permissions.some(
                      (item) => item.permission_id == "9" && "3"
                    ) && (
                      <Link to="/investigation/add">
                        <button className="btn btn-primary shadow-md me-2">
                          Add New
                        </button>
                      </Link>
                    )}
                    <button
                      class="btn btn-primary ms-auto d-flex align-items-center dark-text-theme-10"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-accordion-collapse-1"
                      aria-expanded="true"
                      aria-controls="faq-accordion-collapse-1"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-filter w-4 h-4 me-3"
                      >
                        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                      </svg>
                      Filters{" "}
                    </button>
                  </div>

                  <div
                    id="faq-accordion-collapse-1"
                    class="accordion-collapse collapse show show mt-5"
                    aria-labelledby="faq-accordion-content-1"
                    data-bs-parent="#faq-accordion-1"
                  >
                    <div class="grid columns-12 gap-6 mt-5">
                      <div class="intro-y g-col-12 g-col-lg-12">
                        <div class="intro-y box p-5">
                          <div class="row">
                            <div className="col-lg-3 col-md-6 mt-2">
                              <label className="form-label font-weight-bold">
                                Date From
                              </label>
                              <input
                                type="date"
                                name="date_from"
                                value={
                                  multifilters.find(
                                    (filter) => filter.key === "date_from"
                                  )?.value || ""
                                }
                                onChange={handleMultiFilter}
                                className="form-control w-full"
                              />
                            </div>
                            <div className="col-lg-3 col-md-6 mt-2">
                              <label className="form-label font-weight-bold">
                                Date To
                              </label>
                              <input
                                type="date"
                                name="date_to"
                                value={
                                  multifilters.find(
                                    (filter) => filter.key === "date_to"
                                  )?.value || ""
                                }
                                onChange={handleMultiFilter}
                                className="form-control w-full"
                              />
                            </div>
                            <div className="col-lg-3 col-md-4 mt-2">
                              <label className="form-label">Filter</label>
                              <Select
                                isMulti
                                styles={styleSelect}
                                value={multifilterOption || []}
                                onChange={setMultiFilterOption}
                                options={filterOptions}
                              />
                            </div>
                            {multifilters
                              .filter(
                                (filter) =>
                                  !["date_from", "date_to"].includes(filter.key)
                              )
                              .map((filter, index) =>
                                filter.key === "customer_id" ? (
                                  <div
                                    key={index}
                                    className="col-lg-3 col-md-4 mt-2"
                                  >
                                    <label className="form-label font-weight-bold">
                                      Customer Name
                                    </label>
                                    <Select
                                      onChange={
                                        handleMultiFilterDropdownCustomer
                                      }
                                      value={
                                        (customers &&
                                          customers.find(
                                            (cust) =>
                                              cust.customer_id === filter.value
                                          )) ||
                                        null
                                      }
                                      getOptionLabel={(option) =>
                                        `${option.name} - ${
                                          option.mobile || "N/A"
                                        }`
                                      }
                                      getOptionValue={(option) =>
                                        option.customer_id
                                      }
                                      options={customers || []}
                                      styles={styleSelect}
                                    />
                                  </div>
                                ) : filter.key === "insurance_company_id" ? (
                                  <div
                                    key={index}
                                    className="col-lg-3 col-md-4 mt-2"
                                  >
                                    <label className="form-label font-weight-bold">
                                      Insurance Company
                                    </label>
                                    <Select
                                      onChange={
                                        handleMultiFilterDropdownContractor
                                      }
                                      value={{
                                        insurance_company_id: filter.value,
                                        name: filter.label,
                                      }}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) =>
                                        option.insurance_company_id
                                      }
                                      options={
                                        insuranceCompanies &&
                                        insuranceCompanies.length > 0
                                          ? insuranceCompanies
                                          : []
                                      }
                                      styles={styleSelect}
                                      placeholder="Select Insurance Companies"
                                    />
                                  </div>
                                ) : filter.key === "lpoIs" ? (
                                  <div
                                    key={index}
                                    className="col-lg-3 col-md-4 mt-2"
                                  >
                                    <label className="form-label font-weight-bold">
                                      LPO Is
                                    </label>

                                    <Select
                                      onChange={handleMultiFilterDropdownLPO}
                                      value={{
                                        value: filter.value,
                                        label: filter.label,
                                      }}
                                      getOptionLabel={(option) => option.label}
                                      getOptionValue={(option) => option.value}
                                      options={[
                                        { value: 1, label: "True" },
                                        { value: 2, label: "False" },
                                      ]}
                                      styles={styleSelect}
                                      placeholder="LPO Is"
                                    />
                                  </div>
                                ) : filter.key === "bulk_cases" ? (
                                  <div
                                    key={index}
                                    className="col-lg-3 col-md-4 mt-2"
                                  >
                                    <label className="form-label font-weight-bold">
                                      Bulk Cases
                                    </label>

                                    <Select
                                      onChange={handleMultiFilterDropdownBulk}
                                      value={{
                                        value: filter.value,
                                        label: filter.label,
                                      }}
                                      getOptionLabel={(option) => option.label}
                                      getOptionValue={(option) => option.value}
                                      options={[
                                        { value: 1, label: "True" },
                                        { value: 2, label: "False" },
                                      ]}
                                      styles={styleSelect}
                                      placeholder="Bulk Cases"
                                    />
                                  </div>
                                ) : (
                                  <div
                                    key={index}
                                    className="col-lg-3 col-md-4 mt-2"
                                  >
                                    <label className="form-label font-weight-bold">
                                      {
                                        filterOptions.find(
                                          (opt) => opt.value === filter.key
                                        )?.label
                                      }
                                    </label>
                                    <input
                                      type="text"
                                      value={filter.value}
                                      onChange={(event) =>
                                        handleMultiFilter({
                                          target: {
                                            name: filter.key,
                                            value: event.target.value,
                                          },
                                        })
                                      }
                                      className="form-control w-full"
                                    />
                                  </div>
                                )
                              )}
                          </div>
                          <div class="text-end mt-5">
                            <button
                              type="submit"
                              class="btn btn-elevated-primary w-24 me-2"
                              onClick={() =>
                                filterSearch(page, currentRowsPerPage)
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-search w-4 h-4 me-2"
                              >
                                <circle cx="11" cy="11" r="8"></circle>
                                <line
                                  x1="21"
                                  y1="21"
                                  x2="16.65"
                                  y2="16.65"
                                ></line>
                              </svg>
                              Search
                            </button>
                            <button
                              onClick={handleClearFilter}
                              type="button"
                              class="btn btn-elevated-danger w-24"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-x w-4 h-4 me-2"
                              >
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                              </svg>{" "}
                              Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end align-items-center mt-2">
                    <button
                      onClick={handleCopyAllRows}
                      className="btn btn-elevated-primary me-2"
                    >
                      Copy to Clipboard
                    </button>
                    <button
                      type="button"
                      data-bs-target="#bulkJobOutModal"
                      class="btn btn-elevated-primary me-2"
                      data-bs-toggle="modal"
                    >
                      Bulk Job Out
                    </button>
                    <button
                      onClick={handleExport}
                      type="button"
                      class="btn btn-elevated-primary"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-file-text w-4 h-4 me-2"
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                      </svg>
                      Export
                    </button>
                  </div>
                  <div className="intro-y g-col-12 overflow-y-visible h-screen">
                    <div className="mt-2 overflow-x-auto overflow-y-visible h-screen">
                      <DataTable
                        className="overflow-visible"
                        columns={columns.map((column) => ({
                          ...column,
                          cell: column.cell
                            ? column.cell
                            : (row) => <div>{column.selector(row)}</div>,
                        }))}
                        data={jobCards && jobCards.length > 0 ? jobCards : []}
                        progressPending={loading}
                        progressComponent={
                          <ThreeDots
                            height="80"
                            width="80"
                            radius="9"
                            color="#2d3748"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100%",
                            }}
                            wrapperClassName=""
                            visible={loading}
                          />
                        }
                        pagination
                        paginationServer
                        customStyles={customStyles}
                        paginationTotalRows={paginationTotalRows}
                        paginationPerPage={currentRowsPerPage} // Set the default number of rows per page to 30
                        onChangeRowsPerPage={(currentRowsPerPage) =>
                          onChangePage(page, currentRowsPerPage)
                        }
                        onChangePage={(page) =>
                          onChangePage(page, currentRowsPerPage)
                        }
                        selectableRows={true}
                        onSelectedRowsChange={(e) =>
                          handleSelectRows(e.selectedRows)
                        }
                        // actions={actionsMemo}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade show"
                  id="parallelInvestigations"
                  role="tabpanel"
                  aria-labelledby="parallelInvestigations-tab"
                >
                  <div className="intro-y g-col-12 px-3 mt-5 d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-between mt-2">
                    {/* <div className="w-full w-sm-auto mt-3 mt-sm-0 ms-sm-auto ms-md-0">
                                                <div className="w-56 position-relative text-gray-700 dark-text-gray-300">
                                                    <input type="text" className="form-control w-56 box border-white dark-border-dark-3 pe-10 placeholder-theme-13" placeholder="Search..." />
                                                    <i className="w-4 h-4 position-absolute my-auto top-0 bottom-0 me-3 end-0" data-feather="search"></i>
                                                </div>
                                            </div> */}
                    <button
                      class="btn btn-primary ms-auto d-flex align-items-center dark-text-theme-10"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-accordion-collapse-1"
                      aria-expanded="true"
                      aria-controls="faq-accordion-collapse-1"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-filter w-4 h-4 me-3"
                      >
                        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                      </svg>
                      Filters{" "}
                    </button>
                  </div>
                  <div
                    id="faq-accordion-collapse-1"
                    class="accordion-collapse collapse show show mt-5"
                    aria-labelledby="faq-accordion-content-1"
                    data-bs-parent="#faq-accordion-1"
                  >
                    <div class="grid columns-12 gap-6 mt-5">
                      <div class="intro-y g-col-12 g-col-lg-12">
                        <div class="intro-y box p-5">
                          <div class="row">
                            <div className="col-lg-3 col-md-6 mt-2">
                              <label className="form-label font-weight-bold">
                                Date From
                              </label>
                              <input
                                type="date"
                                name="date_from"
                                value={
                                  multifiltersParellel.find(
                                    (filter) => filter.key === "date_from"
                                  )?.value || ""
                                }
                                onChange={handleMultiFilterParellel}
                                className="form-control w-full"
                              />
                            </div>
                            <div className="col-lg-3 col-md-6 mt-2">
                              <label className="form-label font-weight-bold">
                                Date To
                              </label>
                              <input
                                type="date"
                                name="date_to"
                                value={
                                  multifiltersParellel.find(
                                    (filter) => filter.key === "date_to"
                                  )?.value || ""
                                }
                                onChange={handleMultiFilterParellel}
                                className="form-control w-full"
                              />
                            </div>
                            <div className="col-lg-3 col-md-4 mt-2">
                              <label className="form-label">Filter</label>
                              <Select
                                isMulti
                                styles={styleSelect}
                                value={multifilterOptionParellel || []}
                                onChange={setMultiFilterOptionParellel}
                                options={filterOptions}
                              />
                            </div>
                            {multifiltersParellel
                              .filter(
                                (filter) =>
                                  !["date_from", "date_to"].includes(filter.key)
                              )
                              .map((filter, index) =>
                                filter.key === "customer_id" ? (
                                  <div
                                    key={index}
                                    className="col-lg-3 col-md-4 mt-2"
                                  >
                                    <label className="form-label font-weight-bold">
                                      Customer Name
                                    </label>
                                    <Select
                                      onChange={
                                        handleMultiFilterDropdownParellelCustomer
                                      }
                                      value={{
                                        customer_id: filter.value,
                                        name: filter.label,
                                      }}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) =>
                                        option.customer_id
                                      }
                                      options={customers || []}
                                      styles={styleSelect}
                                    />
                                  </div>
                                ) : filter.key === "insurance_company_id" ? (
                                  <div
                                    key={index}
                                    className="col-lg-3 col-md-4 mt-2"
                                  >
                                    <label className="form-label font-weight-bold">
                                      Insurance Company
                                    </label>
                                    <Select
                                      onChange={
                                        handleMultiFilterDropdownParellelContractor
                                      }
                                      value={{
                                        insurance_company_id: filter.value,
                                        name: filter.label,
                                      }}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) =>
                                        option.insurance_company_id
                                      }
                                      options={
                                        insuranceCompanies &&
                                        insuranceCompanies.length > 0
                                          ? insuranceCompanies
                                          : []
                                      }
                                      styles={styleSelect}
                                      placeholder="Select Insurance Companies"
                                    />
                                  </div>
                                ) : filter.key === "lpoIs" ? (
                                  <div
                                    key={index}
                                    className="col-lg-3 col-md-4 mt-2"
                                  >
                                    <label className="form-label font-weight-bold">
                                      LPO Is
                                    </label>

                                    <Select
                                      onChange={
                                        handleMultiFilterDropdownParellelLPO
                                      }
                                      value={{
                                        value: filter.value,
                                        label: filter.label,
                                      }}
                                      getOptionLabel={(option) => option.label}
                                      getOptionValue={(option) => option.value}
                                      options={[
                                        { value: 1, label: "True" },
                                        { value: 2, label: "False" },
                                      ]}
                                      styles={styleSelect}
                                      placeholder="LPO Is"
                                    />
                                  </div>
                                ) : (
                                  <div
                                    key={index}
                                    className="col-lg-3 col-md-4 mt-2"
                                  >
                                    <label className="form-label font-weight-bold">
                                      {
                                        filterOptions.find(
                                          (opt) => opt.value === filter.key
                                        )?.label
                                      }
                                    </label>
                                    <input
                                      type="text"
                                      value={filter.value}
                                      onChange={(event) =>
                                        handleMultiFilterParellel({
                                          target: {
                                            name: filter.key,
                                            value: event.target.value,
                                          },
                                        })
                                      }
                                      className="form-control w-full"
                                    />
                                  </div>
                                )
                              )}
                          </div>
                          <div class="text-end mt-5">
                            <button
                              type="submit"
                              class="btn btn-elevated-primary w-24 me-2"
                              onClick={() => parallelFilterSearch()}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-search w-4 h-4 me-2"
                              >
                                <circle cx="11" cy="11" r="8"></circle>
                                <line
                                  x1="21"
                                  y1="21"
                                  x2="16.65"
                                  y2="16.65"
                                ></line>
                              </svg>
                              Search
                            </button>
                            <button
                              onClick={handleClearParallelFilter}
                              type="button"
                              class="btn btn-elevated-danger w-24"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-x w-4 h-4 me-2"
                              >
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                              </svg>{" "}
                              Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="intro-y g-col-12">
                    <div className="mt-2">
                      <DataTable
                        className="overflow-lg-visible"
                        columns={parallelColumns}
                        data={
                          parallelJobCards && parallelJobCards.length > 0
                            ? parallelJobCards
                            : []
                        }
                        progressPending={loading}
                        progressComponent={
                          <ThreeDots
                            height="80"
                            width="80"
                            radius="9"
                            color="#2d3748"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100%",
                            }}
                            wrapperClassName=""
                            visible={loading}
                          />
                        }
                        pagination
                        paginationServer
                        customStyles={customStyles}
                        paginationTotalRows={paginationTotalRows}
                        onChangeRowsPerPage={(currentRowsPerPage) =>
                          setCurrentRowsPerPage(currentRowsPerPage)
                        }
                        onChangePage={(page) => onChangeParallelPage(page)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- END: Data List --> */}
          </span>
          {/* } */}
          <DocumentModal modalJobCardId={modalJobCardId} jobCard={jobCard} />
          <JobOutModal modalJobCardId={modalJobCardId} jobCard={jobCard} />
          <ItemsModal jobCard={jobCard} />
          <div
            id="bulkJobOutModal"
            className="modal"
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Bulk Job Out</h5>
                </div>
                <div className="modal-body">
                  <div className="form-group mt-2">
                    <label className="form-label" for="payTypeSelect">
                      Pay Type :
                    </label>
                    <select
                      onChange={(e) => setPayType(e.target.value)}
                      className="form-control"
                      id="payTypeSelect"
                    >
                      <option value="unpaid">Unpaid</option>
                      <option value="cash">Cash</option>
                      <option value="settlement">Settlement</option>
                      <option value="card">Card</option>
                      <option value="cheque">Cheque</option>
                    </select>
                  </div>
                  <div className="form-group mt-2">
                    <label className="form-label" for="referenceTextarea">
                      Payment Info :
                    </label>
                    <textarea
                      onChange={(e) => setReferenceBulk(e.target.value)}
                      className="form-control"
                      id="referenceTextarea"
                      rows="3"
                    ></textarea>
                  </div>
                  <div className="form-group mt-2">
                    <label className="form-label" for="dateInput">
                      Date :
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="dateInput"
                      value={payDate}
                      onChange={(e) => setPayDate(e.target.value)}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    onClick={savebulk}
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <Footer /> */}
        </div>
      </div>
    </span>
  );
}
export default JobCard;
